import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import Loading from 'src/Components/Loading/LoadingApp'

const Styleguide = lazy(() =>
  import('src/styleguide' /* webpackChunkName: "styleguide" */)
)

const StyleguideRoutes = ({ rootDir }) => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route path={rootDir} component={Styleguide} />
      <Redirect to='/' />
    </Switch>
  </Suspense>
)

export default StyleguideRoutes
